<template>
    <div>
        <div v-html="lp.header"></div>

        <div v-if="lp.title" class="tech-top-wrap">
            <h1 class="txt54 mobile-only mobile-title">{{ lp.title }}</h1>
            <div class="tech-top-img">
                <img :src="lp.cover.imageURL" v-bind:alt="lp.cover.altText ? lp.cover.altText : null" />
            </div>
            <div class='tech-top-frame light-blue-line'>
                <h1 class="txt54 desktop-only">{{ lp.title }}</h1>
                <div v-html="lp.body"></div>
            </div>
        </div>



        <div class="know-list-wrap">
            <div v-for="movie in movies" :key="movie._id" class="know-item blog-item">
                <div class="movieContainer">
                    <!-- <iframe :src="movie.movileURL"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        width="100%" height="100%" frameBorder="0"></iframe> -->

                    <iframe
                        :src="movie.movileURL + '?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"></iframe>

                </div>
                <img v-if="movie.cover" :src="movie.cover.imageURL" class="know-item-image"
                    v-bind:alt="movie.cover.altText ? movie.cover.altText : null" />
                <p class="know-item-head">{{ movie.title }}</p>
                <p class="know-item-txt" v-html="movie.description"></p>
                <a class="btn lowcase downloadBtn" :href="movie.downloadURL" target="_blank"><img
                        src="../assets/downloadIcon.png" />Download</a>
            </div>
        </div>

        <div v-if="lp.footer" class="land-footer" v-html="lp.footer">
        </div>


        <SocialMenu pagename="landing" :phoneForWhatsapp="lp.phoneForWhatsapp" whatsappOnly="true" :vendor="``"
            :title="`landing`" :color="'white'" :size="20" class="whatsapp-only social-menu small" />

        <botfooter v-if="!lp.footer"></botfooter>


    </div>
</template>


<script>
import Botfooter from "@/components/Botfooter.vue";
import axios from 'axios';
import SocialMenu from "../components/SocialMenu.vue";

export default {
    metaInfo() {
        return {
            ssrAppId: "sela",
            ...this.seo({
                title: this.lp.title,
                description: this.lp.blurb,
                image: this.event?.thumbnail?.imageURL || this.lp.cover?.imageURL,
            }),
        };
    },
    components: {
        Botfooter,
        SocialMenu
    },
    data: () => ({
        now: new Date(),
        formStatus: "",
        form: {
            pageName: "",
            pageId: "",
            fullName: "",
            email: "",
            company: "",
            phone: "",
            jobTitle: "",
            region: null,
            utmsource: "",
        },
        checkboxChecked: false,
        ValidationTypeEnum: {
            AlphaBet: /^[a-zA-Z ]+$/,
            Email: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/,
            Phone: /^(\+)?(?:[0-9-()/.\s?]){6,15}[0-9]{1}$/,
            Required: /.+/
        },
        hasFalseProp: false,
        formErrors: {},
    }),

    watch: {

    },
    computed: {
        lp() {
            const { id } = this.$route.params;
            const lp = this.$local.recordingPages?.find((c) => c.slug == id);

            return lp
        },
        movies() {
            return this.lp.movies;
        }
    },
    mounted() {
        // const recaptchaScript = document.createElement('script')
        // recaptchaScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
        // document.head.appendChild(recaptchaScript)

        // const script = document.createElement('script');
        // script.id = 'vimeo-api';
        // script.src = 'https://player.vimeo.com/api/player.js';
        // script.async = true;
        // document.head.appendChild(script);


        
        console.log("ver 9.4");
    },
    methods: {
        onError(errorObj) {
            this.formErrors[errorObj.label] = errorObj.validation;

            this.setFalseProp();
        },
        async sendForm() {
            try {
                this.setFalseProp();
                if (this.hasFalseProp) {
                    return; // Stop the form submission if there are errors
                }
                this.formStatus = "sending";
                this.form.pageName = this.lp.name;
                this.form.pageId = this.lp._id;
                let utm_source = sessionStorage.getItem('utm_source');
                if (utm_source)
                    this.form.utmsource = utm_source;

                await axios.post(
                    '/.netlify/functions/submitLandingDetails',
                    this.form
                );
                this.formStatus = "success";
            } catch (err) {
                console.log(err.response.data);
                this.formStatus = "fail";
            }
        },
        setFalseProp() {
            this.hasFalseProp = Object.values(this.formErrors).includes(false);
        },
        replaceUrlInThankyouText(htmlContent) {
            htmlContent = htmlContent.replace(/@FILE_URL@/g, this.lp.pDFForDownload.imageURL);
            console.log(htmlContent);
            return htmlContent;
        }
    },
    name: "Landing",
};

</script>

<style scoped>
.land-form-thanks {
    max-width: 90%;
    margin: auto;
    background: transparent;
    color: white;
    margin-top: 100px;
}

::v-deep .landing-body h1 {
    font-weight: 300;
}

::v-deep .landing-sections {
    display: flex;
    gap: 70px;
    flex-wrap: wrap;
    justify-content: center;
}

::v-deep .landing-item img {
    max-width: 100px;
    max-height: 75px;
    object-fit: contain;
}

::v-deep .landing-sections>div.landing-item {
    flex: 0 0 25%;
    gap: 18px;
}

::v-deep .landing-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

::v-deep .footer-ad {
    margin-top: 100px;
    display: flex;
    max-width: 1170px;
    border: 14px solid var(--light-blue);
    padding: 50px;
    text-align: left;
    gap: 50px;
    align-items: center;
}

::v-deep .footer-ad img {
    max-width: 30%;
}

#requestdemo {
    max-width: 1000px;
    height: 1000px;
    margin: auto;
}

.tech-top-wrap {
    margin-bottom: 120px;
}

.tech-bottom-img {
    margin: 60px -80px 60px 0;
    position: relative;
    z-index: 2;
    flex-basis: 46%;
}

#requestdemo {
    scroll-margin-top: 100px;
}

.tech-bottom-wrap {
    justify-content: space-around;
    margin-top: 100px;
}

.video {
    margin-right: 34px;
}

.video-shadow {
    box-shadow: rgb(0, 219, 232) 25px 25px;
    width: 675px;
}


.demo-title {
    display: flex;
    margin: auto;
    margin-top: 20px;
    gap: 20px;
}

.button-container {
    display: flex;
    justify-content: space-between;
}

.button-container input {
    height: 54px;
    margin: 15px;
}

.demo-title img {
    max-width: 120px;
}

.main-container {
    display: flex;
    flex-direction: column;
}

.mobile-only {
    display: none;
}

.desktop-only {
    display: block;
}


.know-item:hover {
    transform: none;
    filter: none;
}

.downloadBtn {
    width: 100%;
    text-align: center;
}

.downloadBtn img {
    margin-right: 12px;
    width: 18px;
}

.movieContainer {
    width: 100%;

}

.movieContainer iframe {
    width: 100%;
    height: 100%;
    min-height: 200px;
}


.blog-item {
    border-radius: 25px;
    padding: 20px;
    box-shadow: 3px 3px 8px #d3d3d3;
}

.blog-item {
    flex-basis: 29.33%;
    margin: 0 2% 40px;
}

.blog-item .know-item-head {}

.blog-pipe {
    padding: 10px;
}

.tech-top-frame {
    padding: 40px 50px 50px 120px;
}

@media screen and (max-width: 991px) {
    .blog-item {
        flex-basis: 44%;
    }

    .tech-top-frame {
        padding: 30px;
    }


}

@media screen and (max-width: 767px) {

    .blogs-top-wrap {
        max-width: 90%;
        padding: 0 0;
    }

    .blogs-subtitle {
        font-size: 25px;
    }

    .blog-item {
        flex-basis: 100%;
    }
}
</style>